import { render, staticRenderFns } from "./CompanySwitcher.vue?vue&type=template&id=ebb4d6aa"
import script from "./CompanySwitcher.vue?vue&type=script&lang=js"
export * from "./CompanySwitcher.vue?vue&type=script&lang=js"
import style0 from "./CompanySwitcher.vue?vue&type=style&index=0&id=ebb4d6aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports